import { LucideIcon } from 'lucide-react'

export interface LoadingSpinnerProps {
  variant?: 'spinner' | 'dots' | 'text'
  size?: 'sm' | 'md' | 'lg'
  color?: string
  message?: string
  icon?: LucideIcon
}

export function LoadingSpinner({
  variant = 'spinner',
  size = 'md',
  color = '#5E6AD2',
  message,
  icon: Icon,
}: LoadingSpinnerProps) {
  const sizeMap = {
    sm: { spinner: 'w-4 h-4', dot: 'w-2 h-2', text: 'text-sm' },
    md: { spinner: 'w-5 h-5', dot: 'w-2.5 h-2.5', text: 'text-base' },
    lg: { spinner: 'w-6 h-6', dot: 'w-3 h-3', text: 'text-lg' },
  }

  const sizes = sizeMap[size]

  if (variant === 'dots') {
    return (
      <div className="flex items-center gap-2 text-[#888888]">
        <div className="flex gap-1">
          <span
            className={`${sizes.dot} rounded-full animate-bounce animate-bounce-delay-0`}
            style={{ backgroundColor: color }}
          />
          <span
            className={`${sizes.dot} rounded-full animate-bounce animate-bounce-delay-150`}
            style={{ backgroundColor: color }}
          />
          <span
            className={`${sizes.dot} rounded-full animate-bounce animate-bounce-delay-300`}
            style={{ backgroundColor: color }}
          />
        </div>
        {message && <span className={sizes.text}>{message}</span>}
      </div>
    )
  }

  if (variant === 'text') {
    return (
      <div className={`text-[#888888] ${sizes.text}`}>
        {message || 'Loading...'}
      </div>
    )
  }

  // Default: spinner variant
  return (
    <div className="flex items-center gap-2 text-[#888888]">
      {Icon ? (
        <Icon className={`${sizes.spinner} animate-spin`} />
      ) : (
        <div
          className={`${sizes.spinner} border-2 border-t-transparent rounded-full animate-spin`}
          style={{ borderColor: color, borderTopColor: 'transparent' }}
        />
      )}
      {message && <span className={sizes.text}>{message}</span>}
    </div>
  )
}
